import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/birthday.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/calculator.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/invoice.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chatify"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/dipmandal353/Chatify"
              demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Invoice-Generator"
              description="This is an invoice generator build with React.js and Bootstrap which takes the content from makdown files and renders it using React.js. You can create any invoice so easily and make it attractive."
              ghLink="https://github.com/dipmandal353/Invoice-generator"
              demoLink="https://invoice-generator-react.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Calculator"
              description="This is a simple calculator build with HTML, CSS & JAVA Script. It will help us to solve any mathematical calculation easily within a snap of time."
              ghLink="https://github.com/dipmandal353/Calculator"
              demoLink="https://dipmandal353.github.io/Calculator/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Birthday Wisher"
              description="This is a countdown based Birthday wisher created by React mainly for those person who don't remember his/her freinds birthday."
              ghLink="https://github.com/dipmandal353/Birthday-wisher"
              demoLink="https://birthday-countdown-wisher.netlify.app/"
            />
          </Col>



      
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
